import { useMutation } from 'react-query';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { authFetchBlob } from '../../CommonUtils/authFetchBlob';

interface FetcherParams {
  clientId: string;
  accountId?: string;
  groupId?: string;
  period?: number;
  startDate?: string;
  endDate?: string;
  tab: 'activity' | 'rgl';
  showActivityDetails?: boolean;
}

const getEndpointURL = (tab: 'activity' | 'rgl', showActivityDetails?: boolean) => {
  if (tab === 'rgl') {
    return '/Consumer/OrionAccountsWidgets/DownloadRealizedGainLossCsv';
  }

  if (showActivityDetails) {
    return '/Consumer/OrionAccountsWidgets/DownloadGroupedTransactionsCsv';
  }

  return '/Consumer/OrionAccountsWidgets/DownloadTransactionsCsv';
};

const downloadActivityCsv = async ({
  clientId,
  accountId,
  groupId,
  period,
  startDate: _startDate,
  endDate: _endDate,
  tab,
  showActivityDetails,
}: FetcherParams) => {
  const startDate = period === undefined ? _startDate : undefined;
  const endDate = period === undefined ? _endDate : undefined;

  const url = getEndpointURL(tab, showActivityDetails);

  return authFetchBlob(
    urlWithParams(
      url,
      {
        clientId,
        accountId: accountId || null,
        groupId: groupId || null,
        period,
        startDate,
        endDate,
      },
      { skipNulls: true },
    ),
  );
};

export const useActivityCsvMutation = () => {
  return useMutation(downloadActivityCsv);
};
